const LocalStorageKeys = {
    lang: 'lang',
    colorMode: 'colorMode',
}

export default LocalStorageKeys;